export default "__VITE_ASSET__be94bc93__"